import { Button, Input, notification, Spin } from 'antd';
import { useState } from 'react';
import { Dynamics } from '@/services/dynamics/dynamics';
import { entityFields } from '@/components/CallPanel/config';
import { LoadingOutlined } from '@ant-design/icons';
import './Forms.scss';
import {
  getFieldValidationConfigForObject,
  validateFormData,
  getErrorIfNotValid,
} from './FormValidationConfig';

const antIcon = <LoadingOutlined spin />;
const FIELD_VALIDATION_CONFIG =
  getFieldValidationConfigForObject('Opportunity');
interface IProps {
  setUnsavedFormData: (data: any) => void;
  data: any;
}

export const NewOpportunityForm = ({ setUnsavedFormData, data }: IProps) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [notificationApi, contextHolder] = notification.useNotification();
  const [formData, setFormData] = useState(
    data?.Opportunity || {
      topic: '',
    },
  );
  const [formDataErrors, setFormDataErrors] = useState({
    topic: '',
  });

  const changeValue = (item: string) => {
    return (e) => {
      setUnsavedFormData({
        Lead: {
          ...formData,
          [item]: e.target.value,
        },
      });
      setFormData({
        ...formData,
        [item]: e.target.value,
      });
      setFormDataErrors({
        ...formDataErrors,
        [item]: getErrorIfNotValid(
          e.target.value,
          FIELD_VALIDATION_CONFIG[item],
        ),
      });
    };
  };

  const validate = () => {
    const errors = {
      topic: '',
    };
    const isOk = validateFormData(formData, errors, FIELD_VALIDATION_CONFIG);
    setFormDataErrors(errors);
    return isOk;
  };

  const showRes = async () => {
    const isValid = validate();
    const data = {
      name: formData.topic?.trim(),
    };
    if (isValid) {
      setIsLoading(true);
      await Dynamics.saveNewEntity('opportunity', data);
      await setFormData({
        topic: '',
      });
      setIsLoading(false);
      setUnsavedFormData(null);
      setTimeout(() => {
        notificationApi.success({
          message: 'Opportunity successfully created',
          placement: 'bottomRight',
          duration: 3,
          className: 'notifications',
        });
      }, 0);
    }
  };
  return isLoading ? (
    <Spin className="spinner" indicator={antIcon} />
  ) : (
    <div>
      {contextHolder}
      <p className="heading">Fill in the form</p>
      <div className="form-container">
        {Object.keys(entityFields.opportunity).map((item) => {
          return (
            <div key={item} className="line">
              {entityFields.opportunity[item]}
              <Input
                placeholder={entityFields.lead[item]}
                value={formData[item]}
                onChange={changeValue(item)}
                status={formDataErrors[item] ? 'error' : ''}
              />
              {formDataErrors[item] ? (
                <div className="form-error">{formDataErrors[item]}</div>
              ) : (
                <></>
              )}
            </div>
          );
        })}
      </div>
      <div className="button-block">
        <Button onClick={showRes} data-testid="create-opportunity">
          Submit
        </Button>
      </div>
    </div>
  );
};
